const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    showMore: () =>
        __('Vis mere'),
};
